import React, {useCallback, useEffect, useState} from "react";
import Dropdown from "../common/dropdown/Dropdown";
import {useSelector} from "react-redux";
import {RoleSign} from "../../enums/enums";
import Icon from "../ui/Icon";

const RoleDropdown = ({onRoleChange}) => {
    const [userDropdownList, setUserDropdownList] = useState([]);

    const formatRole = (role) => ({
        role: role.role,
        roleSign: RoleSign[role.role],
        scope: role.scope,
        scopeId: role.scopeId._id,
        scopeName: role.scopeId.name,
        branchType: role.scopeId?.branchType,
        user: role.user,
        address: role.scopeId.address,
        restaurantName: role.scopeId.restaurantName
    });

    const {
        user,
        selectedRole,
        fetchUserStatus
    } = useSelector(state => state.auth);

    const roleChangeHandler = useCallback((id) => {
        const role = user.userRole.find(role => role.scopeId._id === id);
        onRoleChange(formatRole(role));
    }, [user, onRoleChange]);

    useEffect(() => {
        if (fetchUserStatus === "success") {
            const userList = (user.userRole || []).map(role => ({
                key: role.scopeId._id,
                label: `${role.scopeId.name} (${role.scope} ${role.role})`,
                clickHandler: () => roleChangeHandler(role.scopeId._id),
                active: selectedRole?.scopeId === role.scopeId._id,
            })) || [];
            setUserDropdownList(userList);
        }
    }, [user, fetchUserStatus, selectedRole, roleChangeHandler]);


    const dropdownList = userDropdownList.map(item => ({
        ...item,
        link: item.link || undefined,
        clickHandler: item.clickHandler || undefined,
    }));

    return (
        <>
            {fetchUserStatus === "success" && user.userRole.length > 1 && <Dropdown
                className="dropdown-toggle bg-primary bg-opacity-15 bg-opacity-25-hover py-2 px-4 h-100"
                buttonLabel={`${selectedRole?.scopeName} (${selectedRole?.scope} ${selectedRole?.role})`}
                buttonIcon="user"
                list={dropdownList}
                align="end"/>}
            {fetchUserStatus === "success" && user.userRole.length === 1 && <>
                <span className="fs-md bg-primary bg-opacity-15 rounded-pill px-4 py-2 fw-medium">
                    <Icon name="user" width="19" height="19" className="me-2"/>
                    {`${selectedRole?.scopeName} (${selectedRole?.scope} ${selectedRole?.role})`}</span>
            </>}
        </>
    );
}
export default RoleDropdown;
